module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"order":{"product_options":"已選：{0}"}}}')
  delete Component.options._Ctor
}
